/** localStorage key for the last seen deploy version from `/api/version`. */
export const DEPLOY_VERSION_STORAGE_KEY = "vortixy_deploy_version";

/** localStorage key for the last seen changelog version (e.g. "v2.7") — used to show the "see what's new" prompt only when changelog actually changed. */
export const LAST_SEEN_CHANGELOG_VERSION_KEY = "vortixy_last_seen_changelog_version";

/** sessionStorage flag set right before reload so the post-update prompt can appear once. */
export const SHOW_CHANGELOG_PROMPT_KEY = "vortixy_show_changelog_prompt";

/** Query param on `/changelog` that scrolls to / emphasizes the newest release. */
export const HIGHLIGHT_LATEST_CHANGELOG_PARAM = "highlight";
export const HIGHLIGHT_LATEST_CHANGELOG_VALUE = "latest";
